<template>
  <div
    v-if="
      metaData && (metaData.title || metaData.description || metaData.image)
    "
    class="url-preview relative w-full p-1"
  >
    <button
      @click="$emit('remove')"
      class="cursor-pointer select-none absolute top-1 right-1 z-50"
    >
      <img
        class="bg-white rounded-full h-6 w-6"
        src="@/assets/cancel.svg"
        alt=""
      />
    </button>

    <div class="border rounded-lg overflow-hidden bg-gray-100 dark:bg-zinc-900">
      <!-- Image preview with loading overlay -->
      <div v-if="metaData.image" class="w-full relative">
        <img
          :src="metaData.image"
          alt="Link preview"
          class="w-full object-cover max-h-[200px]"
          @error="handleImageError"
        />
        <ion-spinner
          v-if="isLoading"
          name="crescent"
          color="light"
          class="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 size-full"
        />
      </div>

      <!-- Metadata content -->
      <div class="p-3 space-y-1">
        <div
          v-if="metaData.title"
          class="font-bold text-gray-800 dark:text-white line-clamp-2"
        >
          {{ metaData.title }}
        </div>
        <div
          v-if="metaData.description"
          class="text-sm text-gray-600 dark:text-gray-300 line-clamp-2"
        >
          {{ metaData.description }}
        </div>
        <div class="text-xs text-gray-500 dark:text-gray-400 truncate">
          {{ metaData.url }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { IonSpinner } from "@ionic/vue";

defineProps({
  metaData: {
    type: Object,
    required: true,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["remove"]);

const handleImageError = (event) => {
  // Hide the image on error
  event.target.style.display = "none";
};
</script>

<style scoped>
.url-preview {
  transition: all 0.3s ease;
}

.bg-preview {
  background-color: var(--primary-color);
}
</style>
